import { defineMessages } from 'react-intl'

const messages = defineMessages({
  categories: {
    defaultMessage: 'Categories',
    description: 'column picker section default header',
  },
  column: {
    defaultMessage: 'Columns',
    description: 'column picker section header',
  },
  custom: {
    defaultMessage: 'Custom',
    description: 'column picker section header',
  },
  noResultsFound: {
    defaultMessage: 'No results found',
    description: 'column picker search no results message',
  },
  searchForColumns: {
    defaultMessage: 'Search for columns',
    description: 'column picker search input placeholder',
  },
})

export default messages
